import { DateTime } from 'luxon'

const DDMMYYY = 'dd/MM/yyyy'
const HHMM = 'HH:mm'
const formateDateFromDDMMYYYY = (date) => {
  return DateTime.fromFormat(date, DDMMYYY)
}
const formateDateFromHHMM = (date) => {
  return DateTime.fromFormat(date, HHMM)
}

const isMoreThanXDays = (startDate, endDate, limitDay) => {
  if (startDate && endDate) {
    const A = DateTime.fromFormat(endDate, 'yyyy/MM/dd')
    const B = DateTime.fromFormat(startDate, 'yyyy/MM/dd')
    const diffInDays = A.diff(B, 'days').days
    return diffInDays > limitDay
  }
}

export default function () {
  return {
    formateDateFromDDMMYYYY,
    formateDateFromHHMM,
    isMoreThanXDays
  }
}
